import React, { type PropsWithChildren } from 'react';
import type { TargetType } from '@atlassiansox/cross-flow-base-types';
import { ModalTransition, ModalHeader } from '@atlaskit/modal-dialog';
import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { JiraModal as Modal } from '@atlassian/jira-modal/src/ui/jira-modal.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	MODAL,
} from '@atlassian/jira-product-analytics-bridge';
import { useOnboardingModalContext } from '../../../controllers/onboarding-modal-context/index.tsx';

interface OnboardingModalComponentProps {
	targetProduct: TargetType;
	sourceComponent: string;
	ariaLabel: string;
	title: string;
	onClose?: () => void;
}

const modalWrapperStyles = cssMap({
	root: {
		position: 'relative',
	},
});

const modalHeaderStyles = cssMap({
	root: {
		position: 'absolute',
		top: token('space.negative.100'),
		right: token('space.negative.100'),
		zIndex: 100,
	},
});

export const OnboardingModalComponent = ({
	children,
	targetProduct,
	sourceComponent,
	ariaLabel,
	onClose,
}: PropsWithChildren<OnboardingModalComponentProps>): React.JSX.Element => {
	const { open } = useOnboardingModalContext();

	return (
		<ContextualAnalyticsData
			sourceName={sourceComponent}
			sourceType={MODAL}
			attributes={{ targetProduct }}
		>
			<ModalTransition>
				{open && (
					<>
						<FireScreenAnalytics />
						<Modal
							width="x-large"
							shouldScrollInViewport
							testId="cross-flow-onboarding-modal.common.ui.modal.modal"
							messageId="cross-flow-onboarding-modal.common.ui.modal"
							messageType="engagement"
							label={ariaLabel || 'Jira modal'}
							onClose={onClose}
							shouldReturnFocus={false}
						>
							<Box xcss={cx(modalWrapperStyles.root)}>
								<Box xcss={modalHeaderStyles.root}>
									<ModalHeader hasCloseButton />
								</Box>
								{children}
							</Box>
						</Modal>
					</>
				)}
			</ModalTransition>
		</ContextualAnalyticsData>
	);
};
